import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Backdrop,
} from '@mui/material';
import logo from "../styles/logo.png";

const InstructionCard = ({ onAcknowledge }) => {
  const [open, setOpen] = useState(true);
  const { setValue } = useFormContext(); // ✅ Correct usage

  const handleClose = () => {
    setOpen(false);
    onAcknowledge();
  };

  return (
    <Backdrop open={open} sx={{ zIndex: 9999, color: '#fff' }}>
      <Box sx={{ maxHeight: '90vh', overflowY: 'auto', p: 2 }}>
        <Card
          sx={{
            width: '90vw',
            maxWidth: 600,
            mx: 'auto',
            p: 4,
            textAlign: 'center',
            direction: 'rtl',
            boxShadow: 5,
          }}
        >
          <CardContent>
            <img
              src={logo}
              alt="Logo"
              style={{ width: "120px", marginBottom: "20px" }}
            />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
              مؤسسة الشهداء
            </Typography>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              استمارة جمع معلومات شهداء ومصابي العمليات الحربية والاخطاء العسكرية والعمليات الارهابية
            </Typography>
            {/* <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              تعليمات مهمة قبل تعبئة الاستمارة
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, textAlign: 'right' }}>
              1- على ذوي الشهيداوالمصاب ملىء استمارة واحدة فقط<br />
              2- يجب ارفاق البطاقة الوطنية وبطاقة السكن لمقدم الطلب مع الاستمارة<br />
              3- يجب اضافة ثلاث ارقام هواتف غير متوقفة عن العمل
            </Typography> */}

            <Typography variant="h6" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>
              اختر نوع الاستمارة
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setValue("damage", 1); // ✅ this will now work
                  handleClose();
                }}
                sx={{ fontSize: 18, px: 4 }}
              >
                شهيد
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setValue("damage", 2);
                  handleClose();
                }}
                sx={{ fontSize: 18, px: 4 }}
              >
                جريح
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Backdrop>
  );
};

export default InstructionCard;
